import Quantity from '../snippets/Quantity';

export default class CartItem {
  constructor(el, onUpdateCallback) {
    this.el = el;
    this.onUpdateCallback = onUpdateCallback;
    this.id = el.dataset.cartItem;

    this.onQuantityInputChange = () => this._onQuantityInputChange();
    this.onRemoveButtonClick = () => this._removeFromCart();
    this.removeEl = el.querySelector('[data-cart-item-remove]');
    this.quantity = new Quantity(el.querySelector('[data-quantity]'));
    this.removeEl.addEventListener('click', this.onRemoveButtonClick);
    this.quantity.input.addEventListener('change', this.onQuantityInputChange);
  }

  unload() {
    this.removeEl.removeEventListener('click', this.onRemoveButtonClick);
    this.quantity.input.removeEventListener('change', this.onQuantityInputChange);
    this.quantity.unload();
  }

  _onQuantityInputChange() {
    const { value } = this.quantity;

    if (value > 0) {
      this._changeCartQuantity(value, this.onUpdateCallback);
    } else {
      this._removeFromCart();
    }
  }

  _removeFromCart() {
    this._changeCartQuantity(0, () => {
      // Add in animation here
      this.onUpdateCallback();
    });
  }

  _changeCartQuantity(quantity, callback) {
    window.Shopify.changeItem(this.id, quantity, callback);
  }
}
